export default __webpack_public_path__ + "static/media/NPK.2422169a.png";